module.exports = __webpack_public_path__ + "ba49581f7e42a9121c077a285cde8e29.jpg";